<template>

<app-content :loading="is.loading">

	<app-content-head :title="title" :back="$route.meta.back" :readonly="$authorised('mem/pricing/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />
		<app-content-head-actions-item v-if="!isNew" :disabled="isNew" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body>

		<app-content-box :readonly="$authorised('mem/pricing/access', 'read')">

			<app-input-text label="Name" :maxlength="128" placeholder="Enter name..." v-model="model.name" :validation="$v.model.name" />
			<app-input-text label="Code" :maxlength="32" placeholder="Enter code..." v-model="model.code" :validation="$v.model.code" notes="The code to be entered by users when subscribing to receive the discount." />
			<app-input-text label="Description" :autogrow="true" placeholder="Enter description..." v-model="model.description" :validation="$v.model.description" notes="Describe the terms of the discount in user friendly language as it will be shown if the discount is rejected." />
			<app-input-checklist :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Status" v-model="model.status" :validation="$v.model.type" :options="$constants.registration.discount.statusName" :descriptions="$constants.registration.discount.statusDescription" />
			<app-input-checklist :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Type" v-model="model.type" :validation="$v.model.type" :options="$constants.membership.discount.typeName" :descriptions="$constants.membership.discount.typeDescription" />
			<app-input-text v-if="model.type !== $constants.registration.discount.type.comp" label="Discount" :numeric="true" :prefix="model.type === $constants.registration.discount.type.amount ? '$' : '%'" placeholder="Enter value..." v-model="model.amount.value" :validation="$v.model.amount.value" />
			<app-input-text v-if="model.type === $constants.registration.discount.type.percent" label="Max. Value" notes="The maximum discount that can be given regardless of the actual percentage value." :numeric="true" :toggle="model.amount.max.enabled" v-on:toggle="model.amount.max.enabled = !model.amount.max.enabled" v-model="model.amount.max.value" :validation="$v.model.amount.max.value" />
			<app-input-text label="Cycles" notes="The number of cycles the discount code applies to (default is 1)." :numeric="true" :toggle="model.cycles.enabled" v-on:toggle="model.cycles.enabled = !model.cycles.enabled" v-model="model.cycles.amount" :validation="$v.model.cycles.amount" />
			<app-input-date :time="true" label="Usable From" placeholder="Enter date..." :toggle="model.from.enabled" v-on:toggle="model.from.enabled = !model.from.enabled" v-model="model.from.date" :validation="$v.model.from.date" />
			<app-input-date :time="true" label="Usable Until" placeholder="Enter date..." :toggle="model.to.enabled" v-on:toggle="model.to.enabled = !model.to.enabled" v-model="model.to.date" :validation="$v.model.to.date" />
			<app-input-text label="Code Uses" notes="Maximum number of times this code can be used across all attendees." :numeric="true" :toggle="model.uses.all.enabled" v-on:toggle="model.uses.all.enabled = !model.uses.all.enabled" v-model="model.uses.all.amount" :validation="$v.model.uses.all.amount" />

		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, between, maxValue, minValue } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('mem/pricing/access', 'read'),
			references: {},
			model: {
				id: false,
				name: '',
				code: '',
				description: '',
				status: 0,
				type: 0,
				amount: {
					value: 0,
					max: {
						enabled: 0,
						value: 0
					}
				},
				from: {
					enabled: 0,
					date: 0
				},
				to: {
					enabled: 0,
					date: 0
				},
				cycles: {
					enabled: 0,
					amount: 0
				},
				uses: {
					all: {
						enabled: 0,
						amount: 0
					}
				},
				comp: 0
			}
		}

	},

	validations: function() {

		return {
			model: {
				name: {
					required
				},
				code: {
					required
				},
				description: {
					required
				},
				type: {
					required,
					between: between(1, 3)
				},
				status: {
					required
				},
				amount: {
					value: {
						minValue: minValue(this.amountValueMin),
						maxValue: maxValue(this.amountValueMax)
					},
					max: {}
				},
				cycles: {},
				from: {},
				to: {},
				uses: {
					all: {}
				},
				comps: {}
			}

		}

	},

	computed: {

		amountValueMin: function() {

			return this.model.type === this.$constants.registration.discount.type.comp ? 0 : 1

		},

		amountValueMax: function() {

			return this.model.type === this.$constants.registration.discount.type.percent ? 100 : 10000

		}

	}

}

</script>

<style scoped>

</style>